export const DICTIONARY = {
    root: 'dictionary-root',
    addButton: 'dictionary-add-button',
    keyInput: 'dictionary-key-input',
    displayInput: 'dictionary-display-input',
    categorySelect: 'dictionary-category-select',
    dataTypeSelect: 'dictionary-datatype-select',
    unitInput: 'dictionary-unit-input',
    codeSystemSelect: 'dictionary-codesystem-select',
    codeInput: 'dictionary-code-input',
    submit: 'dictionary-submit',
    search: 'dictionary-search',
    showArchivedToggle: 'dictionary-show-archived',
    row: 'dictionary-row',
    edit: 'dictionary-edit',
    archive: 'dictionary-archive',
    restore: 'dictionary-restore',
};

export const TAGGED_DATA = {
    root: 'tagged-data-root',
    conceptFilter: 'tagged-data-concept-filter',
    memberFilter: 'tagged-data-member-filter',
    exportButton: 'tagged-data-export',
    row: 'tagged-data-row',
};

export const LAB_TEST_ADMIN = {
    conceptSelect: 'lab-test-concept-select',
};

export const CHECKIN_ADMIN = {
    conceptSelect: 'check-in-step-concept-select',
    conceptSearch: 'check-in-step-concept-search',
};
